import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FilterIcon } from "../../../../assets";
import ResourceList from "../../../../components/resourceList/ResourceList";
import Input from "../../../../components/input/Input";
import SecondaryButton from "../../../../components/secondaryButton/SecondaryButton";
import Checkbox from "../../../../components/checkbox/Checkbox";
import BulkReassignVendingControllersModal from "../../../../components/modals/bulkReassignVendingControllersModal/BulkReassignVendingControllersModal";
import { fetchActiveVendingControllers } from "../../../../store/actions/admin/vendingControllers";
import vendingControllersService from "../../../../apis/services/admin/vendingControllersService";
import styles from "./ActiveVendingControllers.module.scss";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import moment from "moment";
import classNames from "classnames";

const HEADER_VALUES = [
  { label: "MAC ADRESA", key: "macAddress", sortable: true },
  { label: "SERIJSKI BROJ", key: "serialNumber", sortable: true },
  { label: "KOMPANIJA", key: "company", sortable: false },
  { label: "ADRESA", key: "address", sortable: false },
  { label: "STATUS", key: "status", sortable: false },
  { label: "AKCIJE", sortable: false },
];

const ActiveVendingControllers = ({ openFilter, filterOffline }) => {
  const dispatch = useDispatch();
  const activeVendingControllers = useSelector(
    (state) => state.vendingControllers.activeVendingControllers
  );
  const history = useHistory();

  const { page, perPage, total, data, attempt } = activeVendingControllers || {};
  // Support deep-linking from Intervend: /vending-controllers?searchTerm=<MAC> pre-filters by MAC.
  const [searchTerm, setSearchTerm] = useState(
    () => new URLSearchParams(window.location.search).get("searchTerm") || ""
  );
  const [selectedControllers, setSelectedControllers] = useState([]);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);

  const isControllerSelected = (controller) =>
    selectedControllers.some((selected) => selected.id === controller.id);

  const onToggleController = (controller) =>
    setSelectedControllers((prev) =>
      prev.some((selected) => selected.id === controller.id)
        ? prev.filter((selected) => selected.id !== controller.id)
        : [...prev, controller]
    );

  const allOnPageSelected =
    (data || []).length > 0 && data.every(isControllerSelected);

  const onSelectAll = () =>
    setSelectedControllers((prev) => {
      const pageIds = new Set((data || []).map((controller) => controller.id));
      const allSelected =
        (data || []).length > 0 &&
        data.every((controller) =>
          prev.some((selected) => selected.id === controller.id)
        );
      if (allSelected) {
        return prev.filter((selected) => !pageIds.has(selected.id));
      }
      return [
        ...prev,
        ...data.filter(
          (controller) =>
            !prev.some((selected) => selected.id === controller.id)
        ),
      ];
    });

  const onBulkReassignSuccess = () => {
    setSelectedControllers([]);
    setBulkModalOpen(false);
    dispatch(
      fetchActiveVendingControllers(
        page || 1,
        perPage || 15,
        searchTerm,
        filterOffline
      )
    );
  };
  const searchVendingControllers = _.debounce((searchTerm) => {
    dispatch(fetchActiveVendingControllers(1, perPage || 15, searchTerm, filterOffline));
  }, 600);

  useEffect(() => {
    dispatch(fetchActiveVendingControllers(1, 15, "", filterOffline));
  }, [dispatch, filterOffline]);

  useEffect(() => {
    searchVendingControllers(searchTerm);
  }, [searchTerm]);

  const onLoadPage = (newPage) => {
    dispatch(fetchActiveVendingControllers(newPage, perPage || 15, searchTerm, filterOffline));
  };

  const onSort = (sortBy, order) => {
    // Sorting can be implemented if needed
    dispatch(fetchActiveVendingControllers(1, perPage || 15, searchTerm, filterOffline));
  };

  const renderVendingControllerRow = (controller, index) => {
    const lastTimeOnline = controller.lastOnlineAt
      ? moment(controller.lastOnlineAt)
          .tz(moment.tz.guess())
          .format("DD.MM.YYYY HH:mm")
      : "Nikad";
    const isOnline =
      controller.lastOnlineAt && new Date().getTime() - new Date(controller.lastOnlineAt).getTime() < 600 * 1000;

    return (
      <div
        className={classNames(styles.row, index % 2 === 0 ? styles.even : styles.odd)}
        key={controller.id}
        onClick={() => history.push(`/vending-controllers/${controller.id}`)}
      >
        <div className={styles.cell}>
          <div className={styles.checkBoxWrap}>
            <Checkbox
              onCheck={() => onToggleController(controller)}
              checked={isControllerSelected(controller)}
            />
          </div>
          <a
            href={`https://sdf.rs/vending-controllers/${controller.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.aTag}
            onClick={(e) => e.stopPropagation()}
          >
            <p>{controller.macAddress || "-"}</p>
          </a>
        </div>
        <div className={styles.cell}>
          <p>{controller.serialNumber || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>{controller?.fiscalDevice?.businessUnit?.company?.name || "-"}</p>
        </div>
        <div className={styles.cell}>
          <p>{controller?.fiscalDevice?.businessUnit?.address?.name || "-"}</p>
        </div>
        <div className={styles.cell}>
          <div className={styles.statusWrapper}>
            <div className={classNames(styles.statusIndicator, isOnline ? styles.online : styles.offline)} />
            <p>{lastTimeOnline}</p>
          </div>
        </div>
        <div className={styles.cell}>
          <button
            className={styles.viewButton}
            onClick={(e) => {
              e.stopPropagation();
              history.push(`/vending-controllers/${controller.id}`);
            }}
          >
            Pregled
          </button>
        </div>
      </div>
    );
  };
  return (
    <div className={styles.content}>
      <div className={styles.topPart}>
        <p className={styles.title}>Aktivni</p>
        <div className={styles.flexEnd}>
          <div className={styles.downloadBtnWrap}>
            <SecondaryButton
              name="Izvezi u XLS"
              onClick={() => {
                vendingControllersService.downloadXLs();
              }}
            />
          </div>
          <div className={styles.downloadBtnWrap}>
            <SecondaryButton
              name="OTA XLSX"
              onClick={() => {
                vendingControllersService.downloadOtaExport("xlsx");
              }}
            />
          </div>
          <div className={styles.downloadBtnWrap}>
            <SecondaryButton
              name="OTA CSV"
              onClick={() => {
                vendingControllersService.downloadOtaExport("csv");
              }}
            />
          </div>
          <div
            className={classNames(
              filterOffline ? styles.filterIconActive : styles.filterIconWrap
            )}
          >
            <img
              src={FilterIcon}
              className={styles.filterIcon}
              fill={"red"}
              alt="left"
              onClick={() => {
                openFilter();
              }}
            />
          </div>
          <div className={styles.inputWrapper}>
            <Input
              onChange={(value) => {
                setSearchTerm(value);
              }}
              value={searchTerm}
              placeholder={searchTerm === "" && "Search"}
            />
          </div>
        </div>
      </div>
      {selectedControllers.length > 0 && (
        <div className={styles.selectionBar}>
          <p>{selectedControllers.length} izabrano</p>
          <SecondaryButton
            name="Promeni fiskalni uređaj"
            onClick={() => setBulkModalOpen(true)}
          />
          <SecondaryButton
            name="Poništi izbor"
            onClick={() => setSelectedControllers([])}
          />
        </div>
      )}
      <div className={styles.listWrapper}>
        <ResourceList
          selectable={true}
          onSelectAll={onSelectAll}
          selectAll={allOnPageSelected}
          resource={{
            data: data || [],
            total: total || 0,
            page: page || 1,
            perPage: perPage || 15,
            attempt: attempt || false,
          }}
          headerValues={HEADER_VALUES}
          onLoadPage={onLoadPage}
          onSort={onSort}
          rowRender={renderVendingControllerRow}
          showLoader={true}
        />
      </div>
      <BulkReassignVendingControllersModal
        modalOpen={bulkModalOpen}
        onClose={() => setBulkModalOpen(false)}
        selectedControllers={selectedControllers}
        onSuccess={onBulkReassignSuccess}
      />
    </div>
  );
};

export default ActiveVendingControllers;
